import { gql } from "@apollo/client";

const AddProjectMutation = gql`
  mutation addProjectMutation($projectName: String!) {
    createProject(input: { project: { projectName: $projectName } }) {
      project {
        id
        isActive
        projectName
      }
    }
  }
`;

const hash = "d60223773fdd9dd347f06673810d609159e9dcba35f0f918392e9267d5b2fbb7";

export { AddProjectMutation, hash };
